import { icons as iconsImage } from 'assets';
import { useBalanceStore } from 'providers/balance';
import React from 'react';
import { capitalize } from 'utils/stringServices';
import Text from '../text';

import styles from './cards.module.css';
/**
 * This components enables the user to display various type of wallet cards
 * 
 *
 * @param {naira | dollar | euro} symbol This is the sybbol to be used to represents the card
 * @returns JSX.Element
 */
const WalletCard = ({ onClick, symbol,amount, background,viewable,onRefresh=()=> {}, balance, style, ...props}) => {
    const currency = {
        naira: "₦",
        euro:"€",
        dollar:"$"
    }
    const [isRefreshing, setIsRefreshing] = React.useState(false);
    const {showBalance} = useBalanceStore();
    const clickHandler = () =>{
        setIsRefreshing(true);
        onRefresh(()=>{
            setIsRefreshing(false);
        })
    }
    return (
        <div className={`${styles.Wallet} `} style={{background:!background?"unset":background, ...style}} onClick={!viewable ? onClick : () => {}}>
            {balance ? null : <Text className={styles.symbol} style={{lineHeight:"110%",marginBottom:"-8px"}}>{currency[symbol]}</Text>}
            <div>
                {balance ? <Text variant="xs">Card balance</Text>  : <Text variant="xs">{capitalize(symbol)} balance</Text> }
                <div className='row-start' style={{alignItems:"baseline", gap:"1rem"}}>
                    <Text variant="lg"  style={{fontWeight:800, paddingTop: balance ? 20 : null}}>{showBalance ? `${currency[symbol]}${amount}` : "***"}</Text>
                    <img src={iconsImage.refresh} alt="refresh"   
                    className={`${isRefreshing ? styles.refresh : ""}`} style={{cursor:"pointer" }} onClick={clickHandler}/>
                </div>
            </div>
            {viewable && <Text variant="sm" onClick={onClick} className={styles.viewable}>
                View <img src={iconsImage.arrowRight} alt="arrow"  style={{paddingLeft:"8px"}}/>
            </Text>}
        </div>
    )
}

export const HomeWalletCard = ({ onClick, data, onRefresh,...props}) => {
    const icons = {
        naira: "₦",
        euro:"€",
        dollar:"$"
    }
    const {showBalance} = useBalanceStore();

    const [active, setActive] = React.useState("naira");
    const [isRefreshing, setIsRefreshing] = React.useState(false);
    const clickHandler = () =>{
        setIsRefreshing(true);
        onRefresh(()=>{
            setIsRefreshing(false);
        })
    }
    return (
        <div className={styles.Wallet}>
            <div className="w-full">
                <Text variant="xs">Total Balance</Text>
                <div className='row-start' style={{alignItems:"baseline", gap:"1rem"}}>
                    <Text variant="lg"  style={{fontWeight:800}}>{showBalance ? `${icons[active]}${data[active]}` : "***"}</Text>
                    <img src={iconsImage.refresh} alt="refresh"   className={`${isRefreshing ? styles.refresh : ""}`} style={{cursor:"pointer" }} onClick={clickHandler}/>
                </div>
            </div>
            <div className='w-full row-start' style={{gap:"14px"}}>
                <Text variant="xs" color="secondary" style={{fontSize:'11px'}}>VIEW BAL IN</Text>
                <div className='row-start' style={{gap:"10px"}}>
                    <Currency onClick={() =>setActive("naira")} active={active==="naira"} symbol="₦" />
                    <Currency onClick={() =>setActive("dollar")} active={active==="dollar"} symbol="$" />
                    <Currency onClick={() =>setActive("euro")} active={active==="euro"}   symbol="€" />
                </div>
            </div>
        </div>
    )
}
const Currency = ({onClick, active, symbol}) => {
    return(
        <Text className={`${styles.Currency} ${active?styles.active:""}`} onClick={onClick}>
            {symbol}
        </Text>
    )
}
/**
 * For rendering wallet Currency Card
 * @param {naira | dollar | euro} param0 This is what determine the type of card shown
 * @returns JSX.Element
 */
export const CurrencyCard = ({ onClick, symbol,amount,variant,onRefresh=(cb)=> {},className, ...props}) => {
    const [isRefreshing, setIsRefreshing] = React.useState(false);
    const {showBalance} = useBalanceStore();
    const icons = {
        naira: "₦",
        euro:"€",
        dollar:"$"
    }
    const clickHandler = () =>{
        setIsRefreshing(true);
        onRefresh(()=>{
            setIsRefreshing(false);
        })
    }
    return (
        <div className={`${styles.Wallet} ${styles[variant]} ${className || ""}`} {...props}>
            <div className="w-full">
                <Text variant="xs" color="tertiary">Total Balance</Text>
                <div className='row-start' style={{alignItems:"baseline", gap:"1.5rem"}}>
                    <Text variant="xl" color="tertiary" style={{fontWeight:800}}>{showBalance ?`${icons[symbol]}${amount}`:"***"}</Text>
                    <img src={iconsImage.refreshWhite}  alt="refresh" className={`${isRefreshing ? styles.refresh : ""}`} style={{cursor:"pointer" }} onClick={clickHandler}/>
                </div>
            </div>
            </div>
    )
}

export default WalletCard;